import React from 'react';

function diff(target) {
  const total = Math.max(0, target - Date.now());
  return {
    days: Math.floor(total / (1000 * 60 * 60 * 24)),
    hours: Math.floor((total / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((total / (1000 * 60)) % 60),
    seconds: Math.floor((total / 1000) % 60),
  };
}

// Counts down to a fixed launch date.
export default function Countdown({ target }) {
  const [time, setTime] = React.useState(() => diff(target));

  React.useEffect(() => {
    const id = setInterval(() => setTime(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const units = [
    { label: 'Days', value: time.days },
    { label: 'Hours', value: time.hours },
    { label: 'Mins', value: time.minutes },
    { label: 'Secs', value: time.seconds },
  ];

  return (
    <div className="grid w-full max-w-md grid-cols-4 gap-2 sm:gap-4">
      {units.map((u) => (
        <div
          key={u.label}
          className="group relative flex min-w-0 flex-col items-center overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] px-1 py-3 backdrop-blur-sm sm:px-3 sm:py-4"
        >
          {/* Fire underglow on each tile */}
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-ember-500/15 to-transparent opacity-60 transition-opacity duration-500 group-hover:opacity-100" />
          <span className="relative font-display text-2xl font-bold tabular-nums text-white sm:text-4xl">
            {String(u.value).padStart(2, '0')}
          </span>
          <span className="relative mt-1 text-[0.55rem] font-medium uppercase tracking-[0.18em] text-white/40 sm:text-[0.65rem] sm:tracking-[0.2em]">
            {u.label}
          </span>
        </div>
      ))}
    </div>
  );
}
